import { useQuery } from 'react-query'
import { analyticsAPI } from '../../services/api'
import { useAuthStore } from '../../stores/authStore'
import ResidentsCard from '../../components/dashboard/ResidentsCard'
import BudgetAllocationCard from '../../components/dashboard/BudgetAllocationCard'
import LegislationDashboardStatsCard from '../../components/dashboard/LegislationStatsCard'
import ComplaintsDisputesStatsCard from '../../components/dashboard/ComplaintsDisputesStatsCard'

function DashboardPage() {
  const { user, isAdmin, isBarangayOfficial } = useAuthStore()

  return (
    <div className="space-y-5">
      <div className='max-w-9xl mx-auto p-2'>
        <h1 className="text-3xl font-bold text-black">
          Community Management & Governance Overview
        </h1>
        <p className="text-md mt-4 font-medium text-black">
          Real-time monitoring of demographic data, fiscal health, legislative progress, and dispute resolution.
        </p>
      </div>
      <ResidentsCard />
      <BudgetAllocationCard />
      <LegislationDashboardStatsCard />
      <ComplaintsDisputesStatsCard />
    </div>
  )
}

export default DashboardPage